// JavaScript module for reading progress bar with debouncing
const article = document.querySelector('.jsTrackReadProgress');
const progressBar = document.querySelector('.jsReadProgressBar');

if (article && progressBar)
{
	// Function to debounce scroll event
	function debounce(func, delay)
	{
		let timeoutId;
		return function()
		{
			const context = this;
			const args = arguments;
			clearTimeout(timeoutId);
			timeoutId = setTimeout(function ()
			{
				func.apply(context, args);
			}, delay);
		};
	}

	// Function to update the reading progress bar
	function updateProgressBar()
	{
		const articleHeight = article.clientHeight;
		let scrollTop = window.scrollY;
		let winHeight = window.innerHeight;
		let scrollPercent = scrollTop / (articleHeight - winHeight);
		let scrollPercentRounded = Math.round(scrollPercent * 100);

		progressBar.setAttribute('value', scrollPercentRounded);
	}

	// Attach the scroll event listener with debouncing
	function attachScrollListener()
	{
		const debouncedUpdateProgressBar = debounce(updateProgressBar, 10);
		document.addEventListener('scroll', debouncedUpdateProgressBar);
	}

	// Initialize the reading progress bar
	function initProgressBar()
	{
		attachScrollListener();
		updateProgressBar();
	}

	// Call the initProgressBar function to start the progress bar
	initProgressBar();
}